<template>
  <Alert type="info" class="mt-2" iconPosition="start" >
    <div>
      <p>Some tests in your cart are eligible for a Family Discount.</p>
      <div class="flex items-center mt-1">
        <Button @click="$emit('addFamilyMember')" color-type="none-stroke" style-text="padding: 0;" class="mr-2.5">Add Family Members</Button>
        <p><span class="discount-percentage">20% Off</span> for them</p>
      </div>
    </div>
  </Alert>
</template>

<script>
import Alert from "@/NewLibrary/Alert.vue";
import Button from "@/NewLibrary/Button.vue";
export default {
  components: {
    Alert,
    Button
  },
}
</script>

<style scoped>
.discount-percentage {
  color: #D10000;
  font-weight: 300;
}
</style>
